import React from 'react';
import { BarcodeExportConfiguration } from '../types/barcode_export_configuration';

export interface BarcodeExportConfigurationContextProps {
  barcodeExportConfigurations: Map<string, BarcodeExportConfiguration>;
  setBarcodeExportConfigurations: (barcodeExportConfigurations: Map<string, BarcodeExportConfiguration>) => void;
  barcodeExportConfigurationsLoading: boolean;
}

const defaultContext: BarcodeExportConfigurationContextProps = {
  barcodeExportConfigurations: new Map(),
  setBarcodeExportConfigurations: () => {},
  barcodeExportConfigurationsLoading: false,
};

export const BarcodeExportConfigurationContext =
  React.createContext<BarcodeExportConfigurationContextProps>(defaultContext);
